export const PARTNER = 'PARTNER';
export const UPDATE_PARTNER = 'UPDATE_PARTNER';
export const CLEAR_PARTNER = 'CLEAR_PARTNER';
export const LOAD_PAGES = 'LOAD_PAGES';
export const LOAD_W9 = 'LOAD_W9';
export const SET_SELECTED_PAGE = 'SET_SELECTED_PAGE';
